module.exports = __webpack_public_path__ + "static/img/智能控制系统定制.15546a17.png";